import { mapSingleAddressData } from './mapSingleAddress'

export const mapAddressSubscriptionData = customerData => {
  const addresses = customerData?.contact?.addresses ?? []
  const data = {}

  addresses.forEach(address => {
    if (address?.id) {
      data[address.id] = mapSingleAddressData(address)
    }
  })
  return data
}
